import React from 'react';
import { ApMenu, ApButtonIcon, ApMenuItem } from '@alixpartners/ui-components';

import { Label, Wrapper } from './styles';
import { EXPORT_OPTIONS } from 'Pmi/constants';

export const ChartOptions = props => {
	const { label, onPngExportClick, exportId, onExportData } = props;

	const handleExportSelect = selectedItem => {
		if (selectedItem.value === 'png') {
			onPngExportClick && onPngExportClick(exportId);
		} else if (selectedItem.value === 'xlsx') {
			onExportData && onExportData();
		}
	};

	return (
		<Wrapper>
			<Label>{label}</Label>
			<ApMenu button={<ApButtonIcon iconName="download" />}>
				{EXPORT_OPTIONS.map(option => (
					<ApMenuItem
						key={option.value}
						onClick={() => handleExportSelect(option)}
					>
						{option.label}
					</ApMenuItem>
				))}
			</ApMenu>
		</Wrapper>
	);
};

export default ChartOptions;
